'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024proto$0024$002dFile$002dContent from "./presto.types$proto$-File-Content.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$FileContent$() {
}
export { $c_Lpresto_types$proto$FileContent$ as $c_Lpresto_types$proto$FileContent$ };
$p = $c_Lpresto_types$proto$FileContent$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$FileContent$;
/** @constructor */
function $h_Lpresto_types$proto$FileContent$() {
}
export { $h_Lpresto_types$proto$FileContent$ as $h_Lpresto_types$proto$FileContent$ };
$h_Lpresto_types$proto$FileContent$.prototype = $p;
$p.l = (function() {
  return "FileContent";
});
$p.cHN = (function(x$0) {
  return new $j_presto$002etypes$0024proto$0024$002dFile$002dContent.$c_Lpresto_types$proto$FileContent(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_types$proto$FileContent$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$FileContent$, "presto.types$proto$FileContent$", ({
  a3l: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$proto$FileContent$ as $d_Lpresto_types$proto$FileContent$ };
var $n_Lpresto_types$proto$FileContent$;
function $m_Lpresto_types$proto$FileContent$() {
  if ((!$n_Lpresto_types$proto$FileContent$)) {
    $n_Lpresto_types$proto$FileContent$ = new $c_Lpresto_types$proto$FileContent$();
  }
  return $n_Lpresto_types$proto$FileContent$;
}
export { $m_Lpresto_types$proto$FileContent$ as $m_Lpresto_types$proto$FileContent$ };
//# sourceMappingURL=presto.types$proto$-File-Content$.js.map
